import { useEffect, useState } from "react";
import { Container } from "../../common/components/container/Container";
import { Avatar, Radio, Tooltip } from "antd";
import { EquipeManagementConstant } from "./core/_constant";
import { TitleHeader } from "../../common/components/TitleHeader/TitleHeader";

import { useSearchParams } from "react-router";
import { CabotageList } from "./components/teamManagement/cabotage/CabotageList";
import { SalesList } from "./components/teamManagement/sales/SalesList";

const ALL_TYPE = EquipeManagementConstant.TEAM_MANGEMENT_TYPE?.map(
  (item: any) => {
    return {
      ...item,
      component:
        item?.value === EquipeManagementConstant.CABOTAGE_ID ? (
          <CabotageList />
        ) : (
          <SalesList />
        ),
    };
  }
);

export const TeamManagementPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const initialTypeFromURL = searchParams.get("movment");
  const initialType =
    ALL_TYPE.find((item) => item.value === initialTypeFromURL) || ALL_TYPE[0];

  const [teamManagementType, setTeamManagementType] =
    useState<any>(initialType);

  useEffect(() => {
    if (!searchParams.has("movment")) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("movment", ALL_TYPE[0]?.value.toString());
      setSearchParams(newParams);
    }
  }, []);

  const handleChangeType = (value: any) => {
    const finded = ALL_TYPE.find((item) => item.value === value);
    if (!finded) return;

    setTeamManagementType(finded);

    const newParams = new URLSearchParams(searchParams);
    newParams.set("movment", value);
    setSearchParams(newParams);
  };

  return (
    <>
      <div className="">
        <TitleHeader title="Gestion d'équipe" isSHowBack backUri="/app/operations"/>

        <Container className="d-flex flex-column gap-4">
          <div className="">
            <Radio.Group
              options={ALL_TYPE}
              onChange={(e) => handleChangeType(e.target.value)}
              value={teamManagementType.value}
              optionType="button"
              buttonStyle="solid"
            />
          </div>
          {
            ALL_TYPE?.find(
              (item: any) => item?.value === teamManagementType.value
            )?.component
          }
        </Container>
      </div>
    </>
  );
};
